export default __webpack_public_path__ + "static/media/image-1.37e37996.png";